/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import { baseChallengeBodySchema } from '../challenge-body-schema';

export const createChallengeBodySchema = baseChallengeBodySchema;

export type ICreateChallengeBody = z.infer<typeof createChallengeBodySchema>;
